<template>
  <form class="form-table-number" @submit.prevent="submitForm">
    <transition name="fade" mode="out-in">
      <label
        key="retry"
        v-if="error && error === 'retry'"
        class="form-table-number-error"
        for="form-table-number-input"
        >Error: Please retry</label
      >
      <label
        key="NaN"
        v-else-if="error && error === 'NaN'"
        class="form-table-number-error"
        for="form-table-number-input"
        >Enter a valid table number</label
      >
      <label
        key="loading"
        v-else-if="!error && loading"
        class="form-table-number-input-label"
        for="form-table-number-input"
        >Loading...</label
      >
      <label
        key="default"
        v-else
        class="form-table-number-input-label"
        for="form-table-number-input"
        >Enter table number</label
      >
    </transition>
    <div class="form-table-number-input-group">
      <input
        class="form-table-number-input"
        type="number"
        name="tableNumber"
        id="form-table-number-input"
        :value="tableNumber"
        @input="changeTableNumber($event.target.value)"
      />
      <button
        class="form-table-number-button"
        :class="{ 'form-table-number-button--loading': loading }"
        @click="submitForm"
        disable="loading"
      >
        {{ buttonText }}
      </button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      tableNumber: null
    };
  },
  props: {
    buttonText: {
      type: String,
      default: "Submit"
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Boolean, String],
      default: false
    }
  },
  methods: {
    changeTableNumber: function(payload) {
      this.tableNumber = payload;
    },
    submitForm: function() {
      const tableNumber = this.tableNumber;
      return this.$emit("submitForm", tableNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-table-number {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
}
.form-table-number-input-label {
  color: $white;
  width: 100%;
  font-size: 1.1rem;
  text-align: center;
  text-transform: capitalize;
}
.form-table-number-error {
  @extend .form-table-number-input-label;
  color: $red;
}
.form-table-number-input-group {
  display: inline-flex;
  width: 100%;
  margin-top: 0.5rem;
}
.form-table-number-input {
  font-size: 18px;
  background-color: $white;
  text-align: center;
  border-radius: 0;
  margin: 0;
  border: 0;
  padding: 1rem 0.5rem;
  width: 1rem;
  flex: 1;
}
.form-table-number-button {
  background-color: $primary;
  color: $white;
  font-size: 18px;
  border: 0;
  text-transform: uppercase;
  font-family: $header-font-family;
  padding: 1rem 0.5rem;
  white-space: nowrap;
  transition: all ease-in-out 0.25s;
  margin: 0;
  flex:0;
}
.form-table-number-button--loading {
  background-color: $lgreen;
}
</style>
